import "./OurProcess.module.css";
import Header from "@/reusable_sections/Header";
import TheScienceOfALastingFinish from "./sections/TheScienceOfALastingFinish";
import SustainabilityHealth from "./sections/SustainabilityHealth";
import ProjectManagementTimeline from "./sections/ProjectManagementTimeline";
import Footer from "@/reusable_sections/Footer";
export default function OurProcessPage() {
  return <div>
      <Header />
      <TheScienceOfALastingFinish />
      <SustainabilityHealth />
      <ProjectManagementTimeline />
      <Footer />
    </div>;
}